import firebase from "firebase/app";
import "@firebase/firestore";
import { SERVER_URL } from "../Constants";
const firebaseConfig = {
  apiKey: "AIzaSyCL2pquqlER3PCqi6kNZ4bcO4fev58wS3E",
  authDomain: "openleaguescores.firebaseapp.com",
  projectId: "openleaguescores",
  storageBucket: "openleaguescores.appspot.com",
  messagingSenderId: "127606200829",
  appId: "1:127606200829:web:ba0f6559a4ebe549ea2194",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
export const db = firebase.firestore();
export const matchesCollection = db.collection("matches");
export const getMatches = () => {
  return matchesCollection.orderBy("status", "desc").get();
};

export const streamMatches = (observer) => {
  return matchesCollection.orderBy("status", "desc").onSnapshot(observer);
};

export const addMatch = (data) => {
  return matchesCollection.add({
    code: data.code,
    status: 1,
    court: data.court,
    player1: data.player1,
    player2: data.player2,
    set1player1: 0,
    set1player2: 0,
    set2player1: 0,
    set2player2: 0,
    set3player1: 0,
    set3player2: 0,
    scoreplayer1: 0,
    scoreplayer2: 0,
    time: data.time,
  });
};

export const isCodeUnique = (code) => {
  // let isCodeValid;
  return matchesCollection.where("code", "==", code).get();
};

export const updateMatch = (docId, data) => {
  //   fetch(`${SERVER_URL}/editMatch`, {
  //     method: "POST",
  //     body: JSON.stringify({
  //       data: data,
  //       docId: docId,
  //     }),
  //     headers: { "Content-Type": "application/json" },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       console.log(data);
  //     });

  return new Promise((resolve, reject) => {
    fetch(`${SERVER_URL}/editMatch`, {
      method: "POST",
      body: JSON.stringify({
        data: data,
        docId: docId,
      }),
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((message) => {
        resolve(data);
      })
      .catch((err) => reject(false));
  });
};

export const deleteMatch = (docId) => {
  return matchesCollection.doc(docId).delete();
};

export default firebase;
